import { TenantConfig } from '@/types/TenantConfig'

const red = '#d01533'

export const aucklandartgallery: TenantConfig = {
  logo: 'assets/aucklandartgallery/static/logo.svg',

  themeOptions: {
    logoHeight: '40px',
    headerHeight: '60px',
    headerBottomBorder: '1px solid #d9d9d9',
    primaryColor: red,
    secondaryColor: red,
    errorColor: red,
  },

  componentOptions: {
    stripeCreditCard: {
      font: {
        src: 'https://widget.stackla.com/widget/show/?wid=5a5e9bfef1852&ct=&domain=regionalfacilitiesauckland.stackla.com&ttl=30&product_link_attribute=&brand=&categories=&unique_id=0',
        family: 'Theinhardt, Arial, sans-serif',
      },
    },
  },

  i18nOverrides: {
    en: {
      checkoutRoute: {
        title: '',
      },
      dateFormat: {
        medium: 'DD MMMM YYYY',
        long: 'dddd, Do MMMM YYYY',
      },
      dateTimeFormat: {
        long: 'dddd, Do MMMM h:mm A',
      },
    },
  },
}
